<app-public-page-template>
  <div class="button-box">
    @if (errorMessage.length == 0) {
      <p>
        Your download will start in a few seconds. If it doesn't, please click
        <a (click)="downloadInvoice()" href="javascript:void(0)">here</a>
        to open the invoice.
      </p>
    }

    @if (errorMessage.length > 0) {
      <div>
        <b>{{ errorMessage }}</b>
      </div>
    }
  </div>
</app-public-page-template>
<ngx-ui-loader></ngx-ui-loader>